export const logo = '../assets/images/logo.png';
export const station = '../assets/images/station.png';
export const brand_text = '../assets/images/brand_text.png';
